import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";

export class GenericInputModal extends BaseGenericModal {

    public options: BaseGenericModalOptions;
    private template = _.template(require('templates/modals/genericInput.html'));

    constructor(options: BaseGenericModalOptions) {
        super(<any> _.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #genericInputModal': 'handleModalShown',
                'hidden.bs.modal #genericInputModal': 'handleModalHidden',
                'click .generic-input-modal-input': 'handleSubmit',
                'input .generic-input-modal-name': 'handleInput'
            }
        }, options));
        this.genericIdSelector = 'genericInputModal';
    }

    render() {
        var text = this.options.text || "Please enter text below:";
        var buttonText = this.options.buttonText || "Submit";
        var titleText = this.options.titleText;
        var name = this.options.name || '';

        this.$el.html(this.template({
            elementId: 'genericInputModal',
            name: name,
            text: text,
            buttonText: buttonText,
            titleText: titleText
        }));
        return this;
    }

    handleInput() {
        this.handleSubmitButtonDisabledState();
    }

    handleSubmitButtonDisabledState() {
        const name = String(this.$('.generic-input-modal-name').val() || '').trim();
        this.$('.generic-input-modal-input').prop('disabled', name.length === 0);
    }

    handleSubmit() {
        this.options.name = String(this.$('.generic-input-modal-name').val() || '');
        if (!this.options.name.trim()) return;

        this.setFormSubmitted();

        $.when(this.options.func(this.options.name)).done(() => {
            this.hide();
        });
    }

    handleModalShown() {
        this.$('.generic-input-modal-name').focus();
        this.handleSubmitButtonDisabledState();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/GenericInputModal.ts